import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentCreateAction from './equipmentCreate.action.json' with { type: 'json' }
import { equipmentObject } from '../equipmentObject'

const equipmentCreateDefinition = defineAction({
  ...equipmentCreateAction,

  input: equipmentObject.pick({
    title: true,
    type: true,
    plate: true,
    patrimonyNumber: true,
    observation: true,
  }),
  output: z.object({
    id: equipmentObject.shape.id,
  }),
})

export default equipmentCreateDefinition
